/* block-toc.js
 * - Populates TOC lists from H2/H3 headings in the article main column
 *   (Heading blocks, the Content block / article.content, Rich text blocks, and similar).
 * - De-duplicates against items already rendered server-side.
 * - Adds `id` attributes to unanchored content headings so anchor links work.
 * - Hides an empty TOC + collapses the 2-col sidebar layout when no headings exist.
 * - Runs a requestAnimationFrame-throttled scroll-spy to mark the active section.
 */
(function () {
  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9\u00c0-\u024f\-]/gi, '')
      .replace(/^-+|-+$/g, '');
  }

  function isInsideTOC(node) {
    return !!node.closest('.article-template__toc');
  }

  function isInsideOverview(node) {
    return !!node.closest('.article-template__overview');
  }

  function isInsideComments(node) {
    return !!node.closest('.article-template__comment-wrapper');
  }

  function shouldSkip(h) {
    return (
      isInsideTOC(h) ||
      isInsideOverview(h) ||
      isInsideComments(h) ||
      h.classList.contains('article-template__overview-title')
    );
  }

  function populate() {
    var lists = document.querySelectorAll('[data-toc-list]');
    if (!lists.length) return [];

    var main = document.querySelector('.article-template__main') || document;
    var includeH3 = lists[0].getAttribute('data-toc-include-h3') === 'true';
    var selector = includeH3 ? 'h2, h3' : 'h2';

    // Existing items (server-rendered from heading blocks) — index by anchor id
    var existing = new Set();
    lists.forEach(function (list) {
      list.querySelectorAll('li[data-toc-anchor]').forEach(function (li) {
        existing.add(li.getAttribute('data-toc-anchor'));
      });
    });

    var newItems = [];
    main.querySelectorAll(selector).forEach(function (h) {
      if (shouldSkip(h)) return;
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        if (!id) return;
        // Avoid clobbering an existing id elsewhere
        var attempt = id;
        var n = 2;
        while (document.getElementById(attempt) && document.getElementById(attempt) !== h) {
          attempt = id + '-' + n;
          n++;
        }
        id = attempt;
        h.id = id;
      }
      if (existing.has(id)) return;
      existing.add(id);
      newItems.push({ id: id, text: h.textContent.trim(), level: h.tagName.toLowerCase() });
    });

    if (newItems.length) {
      lists.forEach(function (list) {
        newItems.forEach(function (item) {
          var li = document.createElement('li');
          li.className =
            'article-template__toc-item article-template__toc-item--' + item.level;
          li.setAttribute('data-toc-anchor', item.id);
          var a = document.createElement('a');
          a.href = '#' + item.id;
          a.textContent = item.text;
          li.appendChild(a);
          list.appendChild(li);
        });
      });
    }

    // If a TOC list ended up empty, hide that nav. Only collapse the whole aside / grid
    // when the sidebar has no other widgets (e.g. newsletter, recommended product).
    lists.forEach(function (list) {
      if (!list.children.length) {
        var nav = list.closest('[data-toc-root]');
        if (nav) nav.style.display = 'none';
        var aside = list.closest('.article-template__sidebar');
        if (aside) {
          var hasOther = aside.querySelector(
            '.article-template__newsletter, [data-article-reco-sidebar], .article-template__reco--sidebar'
          );
          if (!hasOther) {
            aside.style.display = 'none';
            var grid = aside.closest('.article-template--with-sidebar');
            if (grid) grid.classList.remove('article-template--with-sidebar');
          }
        }
      }
    });

    // Return the flat list of entries used for scroll-spy
    var entries = [];
    lists.forEach(function (list) {
      list.querySelectorAll('li[data-toc-anchor]').forEach(function (li) {
        var id = li.getAttribute('data-toc-anchor');
        var target = id ? document.getElementById(id) : null;
        if (target) entries.push({ li: li, target: target });
      });
    });
    return entries;
  }

  function initScrollSpy(entries) {
    if (!entries.length) return;
    var offset = 120;
    var ticking = false;

    function update() {
      ticking = false;
      var scrollY = window.scrollY + offset;
      var activeTarget = null;
      for (var i = 0; i < entries.length; i++) {
        var top = entries[i].target.getBoundingClientRect().top + window.scrollY;
        if (top <= scrollY) {
          activeTarget = entries[i].target;
        } else {
          break;
        }
      }
      entries.forEach(function (e) {
        e.li.classList.toggle('is-active', e.target === activeTarget);
      });
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    var entries = populate();
    initScrollSpy(entries);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
